<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>I would like to dedicate this book to the author of inspiration and to all the helpers along the way: Belinda, Alex, Denise, Kevin, Pam, the bitumen guy, Jesse, Pete, Skye, James and my mum, Wendy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?60db934b